
export const environment = {
  production: false,
  baseUrl: 'https://abuja.vicpharm.store/apis/v1/vicPharm/',
  ecommerceUrl: 'https://abuja.vicpharm.store/apis/v1/online/ecommerce/'
};